// extracted by mini-css-extract-plugin
export default {"social":"+GtA+"};